import React, { Fragment, useEffect } from 'react'
import PassoutSearchFormView from '../../../../components/exam/report/passout/PassoutSearchFormView';
import { fetchDataFromApi } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { useDispatch } from 'react-redux';
import { EMIS_RPT_Options_List } from '../../../../store/emis_rptSlice';

const EMISPassoutReportFormView = () => {
    const dispatch = useDispatch();
    const EMISReportListView = async ()=>{
        try{
            await fetchDataFromApi(AppURL.EMISRPT+"emis-rpt-options-serach-list-view/").then((res)=>{
                dispatch(EMIS_RPT_Options_List(res));
            });
        }catch(error){
            console.log(error);
        }
    }
    useEffect(()=>{
        EMISReportListView();
    },[]);
    return (
        <Fragment>
            <PassoutSearchFormView />
            
        </Fragment>
    )
}

export default EMISPassoutReportFormView